import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import en from "../../localization/en.json";
import ar from "../../localization/ar.json";

function mapStateToProps(state) {
  const { locale } = state.language;
  const messages = locale === "en" ? en : ar;
  document.body.style.direction = locale === "ar" ? "rtl" : "ltr";
  document.documentElement.style.direction = locale === "ar" ? "rtl" : "ltr";
  return { locale, messages };
}

export default connect(mapStateToProps)(IntlProvider);
